import { configureLocalization } from "@lit/localize";

import { dynamicImportWithRetry } from "@fatso83/retry-dynamic-import";
import { isPresent } from "@whilecat/core/utils/objects.js";
import { sourceLocale, targetLocales } from "../../../translations/locale-codes.ts";

export enum SupportedLanguage {
    RU = "ru_RU",
    EN = "en",
}

const values: SupportedLanguage[] = Object.values(SupportedLanguage);

export function getSupportedLanguages() {
    return values;
}

export function chooseSiteLanguage() {
    const language = localStorage.getItem("language");
    if (isPresent(language)) {
        setLocale(language.toString());
        return;
    }

    const systemLocale = getSystemLocale();

    if (systemLocale.includes("ru")) {
        setCurrentLanguage(SupportedLanguage.RU);
    } else {
        setCurrentLanguage(SupportedLanguage.EN);
    }
}

export function setCurrentLanguage(language: SupportedLanguage) {
    localStorage.setItem("language", language.toString());
    return setLocale(language.toString());
}

export function getCurrentLanguage(): SupportedLanguage {
    return getLocale() as SupportedLanguage;
}

export function getSystemLocale() {
    const locale = navigator.language || navigator.languages[0];
    return locale.toLocaleLowerCase();
}

const { getLocale, setLocale } = configureLocalization({
    sourceLocale,
    targetLocales,
    loadLocale: locale => dynamicImportWithRetry(() => import(`../../../translations/locales/${locale}.ts`)),
});

/*
    1. При первом запуске посмотреть локаль системы/по локации - либо ру/английский
    2. сохранить этот выбор в куки
    3. сделать кнопочку для переключения, которая будет сохранять в куки
    4.
 */
